// This file can be replaced during build by using the fileReplacements array.
// ng build replaces environment.ts with environment.prod.ts.
// The list of file replacements can be found in angular.json.

export const environment = {
  production: false,
  envName: 'dev',
  // baseUrl:'https://api.simpo.ai/',
  meta_config_id: '1584707655459825',
  meta_app_id: '501075632632530',
  // meta_config_id: '1584707655459825',
  // meta_app_id: '501075632632530',
  baseUrl: 'https://newdev-api.simpo.ai/',
  planboardUrl: 'https://dev-planboard.web.app',
  dialerUrl: 'https://dev-dialer.web.app',
  sewaBaseUrl: 'https://stage-api.sews.ai/',
  passbookQRUrl: "qrdev",
  passbookUrl: "https://dev-passbook.web.app",
  askSimpoUrl: "https://stage-asksimpo.web.app",
  // passbookUrl : "http://localhost:4201",
  baseBusinessUrl: "https://newdev-api.simpo.ai/business/",
  // referralUrl : 'http://localhost:3000',
  referralUrl: 'https://dev-refer-earn.web.app',
  // formsUrl: 'http://localhost:5173/',
  formsUrl: "https://dev-forms-d2862.web.app/",
  businessWithOutGateway: 'https://newdev-api.simpo.ai/business/',
  ecommerceWithoutGateway: 'https://newdev-api.simpo.ai/ecommerce/',
  aiAgentsUrl: 'https://stage-writer.simpo.ai/',
  aiBlogSocketUrl: 'wss://stage-blog.simpo.ai/api/v1/agent/',
  aiPostSocketUrl: 'wss://stage-socialmediawriter.simpo.ai/api/v1/agent/',
  aiEmailSocketUrl: 'wss://stage-emailwriter.simpo.ai/api/v1/agent/',
  aiPostUrl: 'https://stage-socialmediawriter.simpo.ai/',
  crmAiUrl: 'https://stage-aicrm.simpo.ai',
  onboardingUrl: 'https://stage-aionboard.simpo.ai',
  aiEcommerceUrl: 'https://stage-aiecommerce.simpo.ai',
  passbookBaseUrl: 'https://newdev-api.simpo.ai/passbook/',
  appointementUrl: "https://newdev-api.simpo.ai/appointment/",
  recommendationUrl: "https://stage-recommendations.simpo.ai/",
  inventoryUrl: 'https://dev-inventory-mgmt.web.app',
  serverIp: 'https://newdev-api.simpo.ai/admin/',
  baseProjectUrl: "https://newdev-api.simpo.ai/pms/",
  newServerIp: 'https://newdev-api.simpo.ai/smm/',
  // recommendationUrl: "https://stage-recommendations.simpo.ai/",
  // projectLensUrl: 'https://dev-projectlens-d17d1.web.app',
  projectLensUrl: 'https://stage-projectlens.web.app/',
  navigatorUrl: 'https://stage-navigator1.web.app/',
  aiWriter: 'https://stage-aiwriter.web.app/',
  // aiWriter: 'http://localhost:5173/',
  horizynUrl: 'https://stage-horizyn.web.app/',
  // recommendationUrl: 'https://stage-recommendations.web.app/',
  // prospectIq: 'https://dev-prospectiq.web.app',
  prospectIq: 'https://stage-prospectiq.web.app',
  prism: 'https://stage-prism.web.app',
  workflowsUrl: 'https://stage-workflows.web.app',
  // baseUrl: 'http://54.236.197.24:8003/',
  regenerateUrl: 'https://dev-api.simpo.ai/admin/',
  // dialerUrl : "https://dev-dialer.web.app",
  urlEndingPoint: "dev.simpo.ai",
  redirectingUrl: 'https://dev-app.simpo.ai',
  iframeRelated: 'https://dev-app.simpo.ai',
  mainFrameUrl: "https://dev.simpo.ai/",
  redirectingOtherSite: 'https://dev.simpo.ai',
  indexHtmlUrl: '<script src="https://durga250720.github.io/blogs/blogs.js"></script>',
  aiGeneratingBaseUrl: "https://dev-websitegenerator.simpo.ai/",
  aiTemplateServiceUrl: 'https://dev-aiplanboard.simpo.ai/',
  hrmsUrl: "https://hrms-web-8681a.web.app",
  credits: 'https://stage-credits.web.app',
  passbookStorage: {
    sasToken: '?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-05-10T01:10:57Z&st=2025-06-13T17:10:57Z&spr=https,http&sig=S13EFXN4J4DYC7iBfkXNEu3eyvcHFtjj1aV46G667WA%3D',
    accountName: 'passbookapp',
    containerName: 'dev-lagubandhu',
    domainEndPoint: '.dev.passbookapp.in',
    erpEndPoint: '.devssp.passbookapp.in'
  },
  firebase: {
    // for facebook login test as prateek has access for stage proficon firebase
    apiKey: 'AIzaSyApQ2YPg4Gz7cG567EnpooA_lhqekfKsME',
    authDomain: 'stage-proficornlabs.firebaseapp.com',
    projectId: 'stage-proficornlabs',
    storageBucket: 'stage-proficornlabs.appspot.com',
    messagingSenderId: '801572740852',
    appId: '1:801572740852:web:44e143c44a0dd5c8a588a1',
    measurementId: 'G-MW1VEYQ1KF',
  },
  linkedinRedirectUrl: "https://dev-app.simpo.ai/admin/marketing/smm-settings/list-channels?type=profile",
  linkedinBusinessRedirectUrl: "https://dev-app.simpo.ai/admin/marketing/smm-settings/list-channels?type=page",
  sasToken:
    '?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-05-10T01:10:57Z&st=2025-06-13T17:10:57Z&spr=https,http&sig=S13EFXN4J4DYC7iBfkXNEu3eyvcHFtjj1aV46G667WA%3D',
  accountName: 'passbookapp',
  containerName: 'dev-lagubandhu',
  domainEndPoint: '.dev.passbookapp.in',
  erpEndPoint: '.devssp.passbookapp.in',
  componentImageUploading: {
    Version: 1.0,
    CredentialsProvider: {
      CognitoIdentity: {
        Default: {
          PoolId: 'us-east-1:d4bc770a-5664-4051-bd66-6861a6efbd9c',
          Region: 'us-east-1',
        },
      },
    },
    IdentityManager: {
      Default: {},
    },
    S3TransferUtility: {
      Default: {
        Bucket: 'dev-beeos',
        Region: 'us-east-1',
      },
    },
  },

  //mapBox for google maps
  mapbox: {
    accessToken:
      'pk.eyJ1IjoibmFpZHUyNTA3IiwiYSI6ImNsZWxjcGlmZTB0ejkzb3BnMndzbmthM2cifQ.BJoCPnd81NYvx_2VUadF2w',
  },

  cmisFileUpload: {
    sasToken: 'sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2029-12-31T23:45:03Z&st=2024-12-18T15:45:03Z&spr=https,http&sig=Qjj5Xe5KiMxvETm6rP%2FZP31i3xDS9t1QuyuKgcY%2FPC8%3D',
    accountName: 'cmisprod',
    containerName: 'prod-cmis'
  },


  //goDaddy SSO Key for dev environment
  goDaddy: {
    ssoKey:
      'sso-key 3mM44UcgzgNc8W_PW9i1fz5K8SYbVT1Mzg1i:PW2vd4zTxF8orAqBYD9VXs',
  },
  // Unsplash access key
  unsplash: {
    UNSPLASH_API_TOKEN: 'iMn43HCZ_FLCMWkZgUtMAjt-p-M6vmaB1Z_3fbetmJA',
  },
  // Shutterstock access key
  shutterstock: {
    SHUTTERSTOCK_API_TOKEN:
      'v2/a2FzcG9FMmlOSnJLRUZsa2gzU01GMFlyS1R4T0RqRkYvNDIwNDgwNjc3L2N1c3RvbWVyLzQvSU1KUHlFRTUwc01rTE95NTJXbDJJWVk4MU5UVGtlN2cwcHVoaEptaUhQVXZCSXZHNExrVVdzR3lXWkVaTXQ1WkRTQ2pkZXJOSEV2Q21sRWpFdFdIRWRBSkFqUzlFa25LTkkxd3FaTFdscENSTUpTZEMwdWtBVXFIS0ZWN3Nnekd6eGRnbElUMnhpeG43TXJ3UXR4Mk8xT0R6TzJQVExES3A1cUdDaXB3UGwwOTZEMVk2MEJkRmJoc21feDItdGpiZGFwQVExOWNwLUw4RVN5RnZzY0V6US94cExqQi1YZDhubE9JVEdITlJySTNR'
  },
  balanceStreamUrl: 'https://stage-tokenvault.simpo.ai/v1/balance/organizations/',
};